import React, {useEffect, useState, Fragment} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ImportTransakcjiWgranaLista from './ImportTransakcjiWgranaLista'
import ImportTransakcjiSend from './ImportTranskacjiSend';
import ImportBNP from '../FormBanki/ImportBNP';
import ImportPKOBP_csv from '../FormBanki/ImportPKOBP_csv';

import ImportTransakcjiListaWspolnot from './ImportTransakcjiListaWspolnot';

import { 
    fetchMieszkancy, 
    fetchPrzelewy, 
    fetchUdzialyKontaAkt,
    fetchGrupy,
    fetchLokale,
    fetchUlice,
    fetchBanki
  } from '../../../../Redux/Actions';
import ImportTransakcjiInd from './ImportTransakcjiInd';

const ImportTransakcji = ( props ) => {

    const {wspolnoty} = props;

    const dispatch = useDispatch();

    const [ pelneDane, setPelneDane ] = useState(undefined);
    const [fileName, setFileName] = useState("");
    const [wczytane, setWczytane] = useState([]);
    const [czyDubel, setCzyDubel] = useState(false);
    const [wybranaWspolnota, setWybranaWspolnota] = useState(undefined);
    const [czyWplataNaKontoGlowne, setCzyWplataNaKontoGlowne] = useState(false);

    const [openInd, setOpenInd] = useState(false); 

    const handleOpenInd = () => setOpenInd( prev => !prev);

    useEffect( ()=> {
        if (wybranaWspolnota && wybranaWspolnota?.id > 0) {
            const {id} = wybranaWspolnota;
            dispatch(fetchMieszkancy(id)); 
            dispatch(fetchPrzelewy(id)); 
            dispatch(fetchUdzialyKontaAkt(id));
            dispatch(fetchGrupy(id));
            dispatch(fetchLokale(id));
            dispatch(fetchUlice(id));
        }
        dispatch(fetchBanki());
    },[dispatch, wybranaWspolnota]);

    const udzialyKontaAkt = useSelector( state => state?.udzialyKontaAkt?.data);
    const grupy = useSelector( state => state?.grupy?.data);
    const ulice = useSelector( state => state?.ulice?.data);
    const lokale = useSelector( state => state?.lokale?.data);
    const mieszkancy = useSelector( state => state?.mieszkancy?.data);
    const przelewy = useSelector( state => state?.przelewy?.data);
    const banki = useSelector( state => state?.banki?.data);

    const clearData = () => {
        setWczytane([]);
        setPelneDane(undefined);
        setFileName("");
        setCzyDubel(false);
        setCzyWplataNaKontoGlowne(undefined);   
    }

    useEffect( () => {
        if (wczytane && wczytane?.length > 0) {
            const temp = [];
            wczytane?.forEach( w => {
                let udzialKontoAkt;
                if (wybranaWspolnota?.id_bank == 1) {
                    udzialKontoAkt = udzialyKontaAkt?.find( u => w.rodzajOperacji !== "prowizja" && u.konto_bankowe.substr(14, u.konto_bankowe.length) == w.odbiorcaKonto && u.id_wspolnoty == wybranaWspolnota.id) 
                } else {
                    udzialKontoAkt = udzialyKontaAkt?.find( u => (u.konto_bankowe === w.nadawcaKonto && w.nadawcaKonto?.length > 0) || (u.konto_bankowe === w.odbiorcaKonto && w.odbiorcaKonto?.length > 0 ))
                }
                
                temp.push({
                    id_transkacji: w?.przelewId,
                    data_operacji: w?.dataOperacji,
                    data_wczytania: w?.dataWczytania,
                    kwota: w?.kwota,
                    id_user: udzialKontoAkt?.id_user,
                    grupa_numer: udzialKontoAkt?.grupa_numer,
                    id_wspolnoty: wybranaWspolnota !== null ? wybranaWspolnota.id : udzialKontoAkt?.id_wspolnoty,
                    nadawca_nazwa: w?.nadawcaNazwa,
                    nadawca_konto: w?.nadawcaKonto,
                    nazwa_transakcji: w?.tytul,
                    nazwa_pliku: w?.plik,
                    operacja: w?.rodzajOperacji,
                    odbiorca_nazwa: w?.odbiorcaNazwa,
                    odbiorca_konto: w?.odbiorcaKonto,                    
                });
            })
            setPelneDane(temp);
        }
    },[wczytane, udzialyKontaAkt, fileName, wybranaWspolnota]);

    const formularzBanku = () => {
        
        switch(wybranaWspolnota?.id_bank) {
            case "0":
                return (
                    <Fragment></Fragment>
                )
            case "6": 
                return (   
                    <ImportBNP
                        setWczytane={setWczytane}
                        setPelneDane={setPelneDane}
                        przelewy={przelewy}
                        setCzyDubel={setCzyDubel}
                    /> );
            case "1":
                return (
                    <ImportPKOBP_csv
                        setWczytane={setWczytane}
                        setPelneDane={setPelneDane}
                        przelewy={przelewy}
                        setCzyDubel={setCzyDubel}
                        setWybranaWspolnota={setWybranaWspolnota}
                        wspolnoty={wspolnoty}
                    />
                );
            default: return (<Fragment>{ wybranaWspolnota && `import nieprzewidziany dla banku ${banki?.find( b => b?.id == wybranaWspolnota?.id_bank)?.nazwa}`}</Fragment>);
        }
    }
    
    return (
        <div className="przelewy">
            <h4 className="nazwa">
                Import przelewów
            </h4>

            <div className='import'>
                <div className='form'>
                    <ImportTransakcjiListaWspolnot
                        wspolnoty={wspolnoty}
                        wybranaWspolnota={wybranaWspolnota}
                        setWybranaWspolnota={setWybranaWspolnota}
                        clearData={clearData}
                    />
                   { formularzBanku()}
                   {
                    wybranaWspolnota && (
                        <button onClick={handleOpenInd}>
                            Wczytaj pojedynczy przelew
                        </button>)
                   }
                </div>
                {
                    czyDubel ? (
                        <span className='red'>Plik o tej nazwie został już kiedyś wczytany.</span>
                    ) : (
                        <div className='tabela'>
                            <ImportTransakcjiWgranaLista 
                                fileName={fileName}
                                pelneDane={pelneDane}
                                wspolnoty={wspolnoty}
                                mieszkancy={mieszkancy}
                                wybranaWspolnota={wybranaWspolnota}
                                setWybranaWspolnota={setWybranaWspolnota}
                                czyWplataNaKontoGlowne={czyWplataNaKontoGlowne}
                                setCzyWplataNaKontoGlowne={setCzyWplataNaKontoGlowne}
                            />
                            <ImportTransakcjiSend
                                pelneDane={pelneDane}
                                setFileName={setFileName}
                                setPelneDane={setPelneDane}
                                setCzyDubel={setCzyDubel}
                                setWczytane={setWczytane}
                                setCzyWplataNaKontoGlowne={setCzyWplataNaKontoGlowne}
                                wybranaWspolnota={wybranaWspolnota}
                            />
                        </div>
                    )
                }
                {
                    openInd && (
                        <ImportTransakcjiInd
                            handleOpenInd={handleOpenInd}
                            wybranaWspolnota={wybranaWspolnota}
                            banki={banki}
                            mieszkancy={mieszkancy}
                            udzialyKontaAkt={udzialyKontaAkt}
                            grupy={grupy}
                            lokale={lokale}
                            ulice={ulice}
                            przelewy={przelewy}
                        />
                    )
                }
            </div>

        </div>
    )
}

export default ImportTransakcji;